import { useRef, useState } from 'react'
import { Box, Button, CircularProgress, InputBase, Stack } from '@mui/material'

import useKeyPress from '../../utils/useKeyPress'
import { ReactComponent as RubricIcon } from '../../assets/icons/magic_sparkles.svg'

import { UploadPDF } from './UploadPDF'

export function GenerateWithAIForm({
  value = '',
  onChange = () => {},
  onSubmit = () => {},
  handlePdfChange = () => {},
  loading = false,
  uploadingPdf = false,
  placeholder = `Describe your ideal rubric (e.g., categories, performance levels). Example: ‘A 3-level rubric focusing on content, structure, and style.’`,
  buttonText = 'Generate',
  imageUrl = null,
  pdfFile,
  onRemovePdf,
  progress,
  type,
}) {
  const [image, setImage] = useState(imageUrl)
  const textFieldRef = useRef(null)

  const handleContainerClick = e => {
    if (textFieldRef.current && !textFieldRef.current.contains(e.target)) {
      textFieldRef.current.focus()
    }
  }

  const handleInputClick = e => {
    e.stopPropagation()
  }

  const handleFormSubmit = e => {
    e.preventDefault()
    // If there's an image, pass `true` to onSubmit to handle image-based rubric
    if (value || pdfFile) onSubmit(!!image)
  }

  useKeyPress(['Enter'], e => {
    e.preventDefault()
    e.stopPropagation()
    if (value || pdfFile) {
      handleFormSubmit(e)
    }
    if (document.activeElement === textFieldRef.current && (value || pdfFile) && !loading) {
      textFieldRef.current.blur()
    }
  })

  return (
    <>
      <Stack
        gap="8px"
        justifyContent="space-between"
        sx={{
          width: '100%',
          bgcolor: 'white',
          borderRadius: '16px',
          padding: '10px 14px',
          fontSize: 16,
          border: '2px solid',
          borderColor: 'primary.main',
          cursor: 'text',
          boxShadow: '0px 0px 0px .5px #dce0e9',
        }}
        onClick={handleContainerClick}
      >
        <InputBase
          fullWidth
          multiline
          inputRef={textFieldRef}
          maxRows={10}
          minRows={4}
          placeholder={pdfFile ? 'Describe how to modify or use your uploaded Rubric.' : placeholder}
          value={value}
          onChange={onChange}
          onClick={handleInputClick}
        />
        {type === 'create' && (
          <UploadPDF
            file={pdfFile}
            handlePdfChange={handlePdfChange}
            progress={progress}
            uploadingPdf={uploadingPdf}
            onRemovePdf={onRemovePdf}
          />
        )}

        {image ? (
          <Box sx={{ position: 'relative', width: 'fit-content', mt: 1 }}>
            <img alt="rubric-attachment" src={image} style={{ width: '140px', height: 'auto', borderRadius: '8px' }} />
            <RubricIcon
              style={{
                position: 'absolute',
                top: '4px',
                right: '4px',
                width: '20px',
                height: '20px',
                cursor: 'pointer',
              }}
              onClick={() => setImage(null)}
            />
          </Box>
        ) : null}
      </Stack>
      {/* Submit button */}
      <Button
        fullWidth
        disabled={loading || (!pdfFile && !value) || uploadingPdf}
        size="large"
        startIcon={
          loading ? (
            <CircularProgress color="inherit" size={20} />
          ) : (
            <Box
              sx={{
                '& svg path': { stroke: 'white' },
              }}
            >
              <RubricIcon
                style={{
                  width: '20px',
                  height: '20px',
                }}
              />
            </Box>
          )
        }
        sx={{
          fontWeight: 600,
          fontSize: 16,
        }}
        variant="contained"
        onClick={handleFormSubmit}
      >
        {buttonText}
      </Button>
    </>
  )
}
